import styled from "styled-components";

export const ErrorMessagesContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  @media screen and (max-width: 665px) {
    flex-direction: column;
  }
`;